import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Configuration and Theme Components
import { ConfigProvider } from "./config/ConfigContext";
import ThemeProvider from "./components/ThemeProvider";
import Analytics from "./components/Analytics";

// Context Providers
import { CartProvider } from "./context/CartContext";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/common/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import NotFoundPage from "./pages/NotFoundPage";

// Main App Component
function App() {
  React.useEffect(() => {
    // Apply global background image at runtime to avoid Webpack build errors with spaces in paths
    document.body.style.backgroundImage = "url('/images/Bella/Product%20Photos/productbackground.JPG')";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.minHeight = "100vh";

    // Cleanup
    return () => {
      document.body.style.backgroundImage = "";
    };
  }, []);

  return (
    <ConfigProvider>
      <ThemeProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/blog/:slug" element={<BlogDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-success/:id" element={<OrderSuccessPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Footer />
          </BrowserRouter>
        </CartProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
